

























import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";

/**
 * Utils
 */
import classes from "@/config/wow/classes";
import roles from "@/config/wow/roles";

/**
 * Components
 */


/**
 * A character category in a group card component.
 */
@Component
export default class CharacterCategory extends Vue {
	/// Properties

	@Prop({default: ""})
	parentIndex!: string;

	@Prop({default: true})
	displayCategoryName!: boolean;

	@Prop({default: () => []})
	categories!: any[];

	@Prop({default: () => []})
	data!: any[];

	@Prop({default: 2})
	labelSize!: number;


	/// Attributes
	get organizedReducedData() {
		return this.reduceDataByType(this.data);
	}

	/// Methods
	reduceDataByType(data: any[]) {
		return data.reduce((arr, c) => {
			const spec = classes[c.class].specs[c.mainSpecNum - 1];
			const specSubRole = spec && spec.subrole ? spec.subrole : 0;
			
			const characterSubRoleIndex = roles.find(x => x.name == c.role)?.subroles.findIndex(x => x == c.subRole);
			const characterSubRole = characterSubRoleIndex && characterSubRoleIndex != -1 ? characterSubRoleIndex : specSubRole;

			if (arr[this.categories[characterSubRole]] == null || arr[this.categories[characterSubRole]].length === 0) {
				arr[this.categories[characterSubRole]] = [c];
			}
			else {
				arr[this.categories[characterSubRole]].push(c);
			}

			return arr;
		}, {});
	}
}
